var map = {
	"./beer-frame.png": 411,
	"./buffet.png": 6554,
	"./data/beverage-data": 6956,
	"./data/beverage-data.json": 6956,
	"./data/fritti-data": 8379,
	"./data/fritti-data.json": 8379,
	"./data/pizza-data": 731,
	"./data/pizza-data.json": 731,
	"./fonts/ADayWithoutSun-EgzW.ttf": 3459,
	"./fonts/BimboFinetipTrial.ttf": 7007,
	"./fonts/Mistrully.ttf": 4520,
	"./footer-logo.png": 8055,
	"./fritti/arancino.png": 1856,
	"./fritti/carne.png": 1941,
	"./fritti/funghi.png": 4244,
	"./fritti/melanzane.png": 9110,
	"./fritti/nduja.png": 640,
	"./fritti/patate.png": 8355,
	"./home-full.png": 4899,
	"./home.png": 6553,
	"./icon/beer.png": 6951,
	"./icon/facebook.png": 3659,
	"./icon/insta.png": 1217,
	"./icon/large-b.png": 4434,
	"./icon/large.png": 2853,
	"./icon/map.png": 5027,
	"./icon/order-w.png": 4743,
	"./icon/order32.png": 8497,
	"./icon/phone-call.png": 9403,
	"./icon/small-b.png": 5271,
	"./icon/small.png": 4040,
	"./impasto.png": 1288,
	"./logo.png": 6949,
	"./pizza-full.png": 8397,
	"./pizza.png": 1401,
	"./pizze/colorata.png": 639,
	"./pizze/diavola.png": 9249,
	"./pizze/mortazza.png": 9722,
	"./pizze/parmigiana.png": 817,
	"./pizze/silana.png": 1265,
	"./pizze/tropena.png": 2375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;